<template>
    <div class="leader-board-component">
        <div class="card leader-board-wrapper">
            <div class="leader-board-toolbar">
                <div class="leader-board-month-nav">
                    <el-tooltip class="item" effect="dark" :content="'Tháng ' + preMonth.format('MM-YYYY')" placement="top-start">
                        <button type="button" class="leader-board-nav-btn" :class="{ 'is-disabled': preMonth > $moment() }" @click="preMonthFn()">
                            <i class="el-icon-arrow-left"></i>
                        </button>
                    </el-tooltip>
                    <div class="leader-board-month-chip">
                        <span class="leader-board-month-label">Kỳ xếp hạng</span>
                        <strong>{{ month.format('MM-YYYY') }}</strong>
                    </div>
                    <el-tooltip class="item" effect="dark" :content="nextMonth <= $moment() ? 'Tháng ' + nextMonth.format('MM-YYYY') : 'Chưa có dữ liệu tháng ' + nextMonth.format('MM-YYYY')" placement="top-start">
                        <button type="button" class="leader-board-nav-btn" :class="{ 'is-disabled': nextMonth > $moment() }" @click="nextMonthFn()">
                            <i class="el-icon-arrow-right"></i>
                        </button>
                    </el-tooltip>
                </div>
                <el-button v-if="checkHcns()" @click="exportExcel()" class="leader-board-export" size="small" type="primary">
                    Export
                    <i class="el-icon-download el-icon-right"></i>
                </el-button>
            </div>

            <div class="leader-board-tabs">
                <el-tabs v-if="[2,3,4,5,6,7].includes(keyAccount) && !checkHcns()" @tab-click="changeTabActive" v-model="tabActive" stretch type="card">
                    <el-tab-pane v-if="[2,3,4,5,6,7].includes(keyAccount)" label="Sales" name="sales"></el-tab-pane>
                    <el-tab-pane v-if="[2,3,4,5,6,7].includes(keyAccount)" label="Sales 4,5" name="sales4.5"></el-tab-pane>
                    <el-tab-pane v-if="[3,4,5,6,7].includes(keyAccount)" label="Sales Leader" name="saleslead"></el-tab-pane>
                    <el-tab-pane v-if="[4,5,6,7].includes(keyAccount)" label="GĐVP" name="gdvp"></el-tab-pane>
                </el-tabs>

                <div class="leader-board-filter" v-if="checkHcns()">
                    <div class="leader-board-filter-item">
                        <el-select filterable @change="changeListSale()" class="w-100" clearable
                                   v-model="form.sale_id"
                                   placeholder="Chọn vị trí">
                            <el-option
                                v-for="item in listSale"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="leader-board-filter-item">
                        <el-select @change="changeTabActive()" v-model="form.branch_id" placeholder="Văn phòng" filterable clearable class="w-100">
                            <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id" />
                        </el-select>
                    </div>
                </div>

                <div class="leader-board-hero">
                    <div class="leader-board-heading text-center">
                        <div class="leader-board-title">
                            {{ listBoardName }}
                            <el-tooltip class="item" effect="dark"
                                        :content="'Bảng xếp hạng tháng sẽ được cập nhật vào mùng 10 hàng tháng'"
                                        placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>
                        <small>Đây là bảng xếp hạng tháng {{ month.format('M') }}</small>
                    </div>

                    <div class="leader-podium-stage">
                        <div class="leader-podium">
                            <div v-for="(config, idx) in podiumConfigs" :key="idx" class="leader-podium-item" :class="config.podiumClass">
                                <el-skeleton v-if="loading" animated>
                                    <template slot="template">
                                        <div class="skeleton-graph">
                                            <img v-if="config.index === 0" width="40" class="leader-podium-crown" src="/media/crown.gif" alt="crown">
                                            <el-skeleton-item variant="div" :style="{ width: config.avatarSize, height: config.avatarSize }" class="leader-podium-avatar-skeleton" />
                                            <div class="leader-podium-copy">
                                                <el-skeleton-item variant="p" style="width: 80px;" />
                                                <el-skeleton-item variant="p" style="width: 80px;" />
                                            </div>
                                        </div>
                                    </template>
                                </el-skeleton>

                                <div v-else class="leader-podium-card">
                                    <img v-if="config.index === 0" width="40" class="leader-podium-crown" src="/media/crown.gif" alt="crown">
                                    <div class="leader-podium-avatar" :style="{ width: config.avatarSize, height: config.avatarSize }">
                                        <img :src="top3[config.index]?.avatar || '/media/default-avatar.png'"
                                             :style="{ border: config.border }"
                                             @error="handleImageError($event)"
                                             class="rounded-circle"
                                             :class="{ 'leader-podium-avatar--winner': config.index === 0 }"
                                             alt="avatar" />
                                    </div>
                                    <p class="leader-podium-name" :class="{ 'leader-podium-name--winner': config.index === 0 }">
                                        {{ top3[config.index]?.name }} {{ top3[config.index]?.user_id === currentUser.id ? '(tôi)' : '' }}
                                    </p>
                                    <p class="leader-podium-score">{{ top3[config.index]?.total | formatVND }}</p>
                                </div>

                                <div class="leader-podium-base" :style="{ background: config.background, height: config.height }">
                                    <span style="font-size:18px">#{{ config.index + 1 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class=" rounded-circle text-center"></div>
                    </div>

                    <div class="leader-board-list-wrapper">
                        <div class="leader-board-list-header">
                            <span>Xếp hạng còn lại</span>
                            <span>{{ others.length }} nhân sự</span>
                        </div>
                        <div class="leaderboard-list list-group bg-light rounded">
                            <div class="leaderboard-other">
                                <div
                                    v-for="(user, index) in others"
                                    :key="index"
                                    class="leaderboard-row list-group-item"
                                    :class="{ 'leaderboard-row--active': user.user_id === currentUser.id }"
                                >
                                    <el-skeleton v-if="loading" animated>
                                        <template slot="template" class="d-flex">
                                            <div class="d-flex">
                                                <el-skeleton-item variant="div" style="border-radius: 50%; width: 36px; height: 36px" />
                                                <div class="d-flex flex-column ">
                                                    <el-skeleton-item variant="p" style="width: 220px; margin-left: 10px; margin-top: 2px" />
                                                    <el-skeleton-item variant="p" style="width: 220px; margin-left: 10px; margin-top: 2px" />
                                                </div>
                                                <el-skeleton-item variant="div" style="border-radius: 50%; width: 20px; height: 20px; margin-left: 20px; margin-top: 8px; " />
                                            </div>
                                        </template>
                                    </el-skeleton>

                                    <template v-else>
                                        <div class="leaderboard-row__main">
                                            <div class="leaderboard-row__avatar-wrap">
                                                <img :src="user?.avatar || '/media/default-avatar.png'"
                                                     class="leaderboard-row__avatar rounded-circle border"
                                                     @error="handleImageError($event)"
                                                     alt="avatar"/>
                                            </div>
                                            <div class="leaderboard-row__content">
                                                <p class="leaderboard-row__name">{{ user?.name }} {{ user.user_id === currentUser.id ? '(tôi)' : '' }}</p>
                                                <p class="leaderboard-row__score">{{ user?.total | formatVND }}</p>
                                            </div>
                                        </div>
                                        <span class="leaderboard-row__rank">{{ index + 4 }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {GET_LEADER_BOARD_MANAGER, GET_LEADER_BOARD_SALE, EXPORT_TOP_LEADER_BOARD_SALE} from "@/core/services/store/report.module";
import {
    HANH_CHINH_KHU_VUC
} from "@/core/config/accountTypeOption";
import {BRANCH_LIST} from "@/core/services/store/service.module";

export default {
    name: "LeaderBoardComponent",
    data() {
        return {
            loading_personal: false,
            loading: false,
            tabActive: "sales",
            listBoardName: "Bảng xếp hạng",
            listBoard: [],
            personal: [],
            podiumConfigs: [
                {
                    index: 1,
                    podiumClass: 'second-place',
                    avatarSize: '64px',
                    border: '3px solid rgba(255, 255, 255, 0.9)',
                    background: 'linear-gradient(180deg, #cfd5df 0%, #aeb6c5 100%)',
                    height: '108px'
                },
                {
                    index: 0,
                    podiumClass: 'first-place',
                    avatarSize: '90px',
                    border: '4px solid rgba(255, 255, 255, 0.95)',
                    background: 'linear-gradient(180deg, #ffd54f 0%, #f4a100 100%)',
                    height: '140px'
                },
                {
                    index: 2,
                    podiumClass: 'third-place',
                    avatarSize: '64px',
                    border: '3px solid rgba(255, 255, 255, 0.9)',
                    background: 'linear-gradient(180deg, #f2c194 0%, #da8d0f 100%)',
                    height: '84px'
                }
            ],
            top3: [],
            others: [],
            month: this.$moment(),
            preMonth: this.$moment(this.month).subtract('1', 'month'),
            nextMonth: this.$moment(this.month).add('1', 'month'),
            role: 1,
            branches: [],
            form: {
                branch_id: '',
                sale_id: 1
            },
            listSale: [
                {
                    id: 1,
                    name: 'Sales'
                },
                {
                    id: 2,
                    name: 'Sales 4, 5'
                },
                {
                    id: 3,
                    name: 'Sales Leader'
                },
                {
                    id: 4,
                    name: 'GDVP'
                },
            ],
        };
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser', 'keyAccount', 'targetPersonal']),
    },
    mounted() {
        this.changeTabActive();
        this.getBranch();
    },
    methods: {
        getBranch() {
            const payload = {
                area_id: this.currentUser && this.currentUser.profile ? this.currentUser.profile.khuvuc_id : ''
            };

            this.$store.dispatch(BRANCH_LIST,payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                })

        },
        checkHcns()
        {
            let accountTypeId = this.currentUser && this.currentUser.account_type ? this.currentUser.account_type.id : '';
            return accountTypeId == HANH_CHINH_KHU_VUC;
        },
        preMonthFn() {
            this.month = this.$moment(this.month).subtract(1, 'month');
            this.preMonth = this.$moment(this.month).subtract(1, 'month');
            this.nextMonth = this.$moment(this.month).add(1, 'month');
            if (this.role === 4) {
                this.getLeaderboardManager();
            } else {
                this.getLeaderboardSale();
            }
        },
        nextMonthFn() {
            if (this.nextMonth <= this.$moment()) {
                this.month = this.$moment(this.month).add(1, 'month');
                this.preMonth = this.$moment(this.month).subtract(1, 'month');
                this.nextMonth = this.$moment(this.month).add(1, 'month');
                if (this.role === 4) {
                    this.getLeaderboardManager();
                } else {
                    this.getLeaderboardSale();
                }
            }
        },
        handleLeaderboard(type) {
            const config = {
                1: {
                    name: 'Bảng xếp hạng Sales',
                    action: () => this.getLeaderboardSale(1),
                },
                2: {
                    name: 'Bảng xếp hạng Sales 4,5',
                    action: () => this.getLeaderboardSale(2),
                },
                3: {
                    name: 'Bảng xếp hạng Sales Leader',
                    action: () => this.getLeaderboardSale(3),
                },
                4: {
                    name: 'Bảng xếp hạng GĐ Văn Phòng',
                    action: () => {
                        this.getLeaderboardSale(4);
                        this.getLeaderboardManager(4);
                    },
                },
            };

            const item = config[type];

            if (item) {
                item.action();
                this.listBoardName = item.name;
            }
        },

        changeTabActive() {
            const mapTab = {
                sales: 1,
                'sales4.5': 2,
                saleslead: 3,
                gdvp: 4,
            };

            this.handleLeaderboard(mapTab[this.tabActive]);
        },

        changeListSale() {
            this.handleLeaderboard(this.form.sale_id);
        },
        handleImageError(event) {
            event.target.src = '/media/default-avatar.png';
        },
        getLeaderboard() {
            console.log('this.tabActive', this.tabActive);
        },
        exportExcel()
        {
            this.$store.dispatch(EXPORT_TOP_LEADER_BOARD_SALE, {
                role: this.role,
                date: this.month.format('YYYY-MM'),
                branch_id: this.form.branch_id
            });
        },

        async getLeaderboardSale(role) {
            this.loading = true;
            if (role) this.role = role;
            let response = await this.$store.dispatch(GET_LEADER_BOARD_SALE, {
                role: this.role,
                date: this.month.format('YYYY-MM'),
                branch_id: this.form.branch_id
            });
            this.personal = response.data;
            this.personal = this.personal?.map(item => {
                return {
                    ...item,
                    total: [2,3,4].includes(this.role) ? item.total_revenue : item.total_personal,
                };
            });
            this.top3 = this.personal ? this.personal.slice(0, 3) : [];
            this.others = this.personal?.slice(3) || [];
            this.loading = false;
        },
        async getLeaderboardManager(role) {
            this.loading = true;
            if (role) this.role = role;
            let response = await this.$store.dispatch(GET_LEADER_BOARD_MANAGER, {date: this.month.format('YYYY-MM')});
            this.personal = response.data;
            this.personal = this.personal?.map(item => {
                return {
                    ...item,
                    total: item.total_revenue ,
                };
            });
            this.top3 = this.personal ? this.personal.slice(0, 3) : [];
            this.others = this.personal?.slice(3) || [];
            this.loading = false;
        }
    },
};
</script>

<style scoped>
.leader-board-component {
    width: 100%;
}

.leader-board-wrapper {
    position: relative;
    overflow: hidden;
    padding: 24px;
    border: 0;
    border-radius: 28px;
    background:
        radial-gradient(circle at top left, rgba(132, 92, 255, 0.16), transparent 34%),
        linear-gradient(180deg, #ffffff 0%, #f6f8ff 100%);
    box-shadow: 0 24px 60px rgba(31, 41, 55, 0.12);
}

.leader-board-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;
}

.leader-board-month-nav {
    display: flex;
    align-items: center;
    gap: 15px;
}

.leader-board-nav-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid rgba(73, 49, 147, 0.14);
    border-radius: 50%;
    background: #fff;
    color: #493193;
    box-shadow: 0 10px 24px rgba(73, 49, 147, 0.08);
    transition: all 0.2s ease;
}

.leader-board-nav-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 14px 28px rgba(73, 49, 147, 0.14);
}

.leader-board-nav-btn.is-disabled {
    opacity: 0.5;
}

.leader-board-month-chip {
    display: flex;
    flex-direction: column;
    min-width: 140px;
    padding: 10px 16px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(73, 49, 147, 0.1);
}

.leader-board-month-label {
    font-size: 12px;
    color: #7f889c;
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.leader-board-month-chip strong {
    font-size: 18px;
    color: #1e2436;
}

.leader-board-export {
    border-radius: 14px;
    box-shadow: 0 12px 24px rgba(73, 49, 147, 0.18);
}

.leader-board-filter {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 18px;
}

.leader-board-filter-item {
    min-width: 0;
}

.leader-board-heading {
    margin-bottom: 20px;
}

.leader-board-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 22px;
    font-weight: 700;
    color: #1f2937;
}

.leader-board-heading small {
    display: block;
    margin-top: 6px;
    color: #6b7280;
}

.leader-podium-stage {
    position: relative;
    margin-bottom: 22px;
}

.leader-podium {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 16px;
    padding: 8px 0 0;
}

.leader-podium-item {
    flex: 1 1 0;
    min-width: 0;
    max-width: 200px;
    text-align: center;
}

.leader-podium-card {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 8px 12px;
}

.leader-podium-crown {
    margin-bottom: -14px;
}

.leader-podium-avatar {
    margin-bottom: 12px;
    margin-top: 16px;
    border-radius: 50%;
    padding: 4px;
    background: linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.7));
    box-shadow: 0 14px 30px rgba(31, 41, 55, 0.18);
}

.leader-podium-avatar img,
.leader-podium-avatar-skeleton {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

.leader-podium-avatar--winner {
    box-shadow: 0 16px 36px rgba(245, 158, 11, 0.3);
}

.leader-podium-name {
    min-height: 40px;
    margin: 0;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.35;
}

.leader-podium-name--winner {
    color: #493193;
}

.leader-podium-score {
    margin: 6px 0 0;
    font-weight: 700;
    color: #0f9f6e;
}

.leader-podium-base {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 14px;
    border-radius: 22px 22px 0 0;
    color: #fff;
    font-weight: 800;
    letter-spacing: 0.04em;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.26);
}

.point-gim {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 142px;
    height: 142px;
    transform: translate(-50%, -52%);
    background: radial-gradient(circle at 35% 35%, rgba(255,255,255,0.7), rgba(217, 217, 217, 0.95));
    border: 12px solid rgba(255,255,255,0.4);
    box-shadow: 0 18px 44px rgba(31, 41, 55, 0.12);
}

.point-gim::before {
    content: '';
    position: absolute;
    top: 26px;
    left: 50%;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #656565;
    transform: translateX(-50%);
}

.leader-board-list-wrapper {
    position: relative;
    z-index: 1;
    padding: 18px;
    border-radius: 26px;
    background: linear-gradient(180deg, rgba(227, 231, 242, 0.88) 0%, rgba(242, 245, 252, 0.96) 100%);
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.8);
}

.leader-board-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
    color: #4b5563;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.leaderboard-list {
    background: transparent !important;
}

.leaderboard-other {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: auto;
    max-height: 400px;
}

.leaderboard-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid rgba(148, 163, 184, 0.16);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.9);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.leaderboard-row:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.leaderboard-row--active {
    background: linear-gradient(135deg, #493193 0%, #6d4fdc 100%);
    color: #fff;
    box-shadow: 0 16px 32px rgba(73, 49, 147, 0.24);
}

.leaderboard-row__main {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.leaderboard-row__avatar-wrap {
    flex: 0 0 auto;
}

.leaderboard-row__avatar {
    width: 42px;
    height: 42px;
    object-fit: cover;
}

.leaderboard-row__content {
    min-width: 0;
}

.leaderboard-row__name,
.leaderboard-row__score {
    margin: 0;
}

.leaderboard-row__name {
    font-weight: 700;
    color: inherit;
}

.leaderboard-row__score {
    color: #0f9f6e;
}

.leaderboard-row--active .leaderboard-row__score {
    color: rgba(255, 255, 255, 0.88);
}

.leaderboard-row__rank {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(73, 49, 147, 0.08);
    color: #493193;
    font-weight: 700;
}

.leaderboard-row--active .leaderboard-row__rank {
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
}

.leaderboard-other::-webkit-scrollbar {
    width: 6px;
}

.leaderboard-other::-webkit-scrollbar-track {
    background: rgba(241, 245, 249, 0.85);
    border-radius: 999px;
}

.leaderboard-other::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #7c3aed 0%, #493193 100%);
    border-radius: 999px;
}

::v-deep .el-tabs__nav.is-top.is-stretch {
    background-color: #edf0f7;
    border-radius: 18px 18px 0 0;
    color: black;

}

::v-deep .el-tabs--card > .el-tabs__header {
    margin-bottom: 20px;
    border-bottom: 0;

}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: 0;

}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: 0;
    height: 44px;
    line-height: 44px;
    color: black;
    transition: all 0.2s ease;
}
.el-tabs__item is-top is-active {
    color: #fff;

}

::v-deep .el-tabs__item:hover,
::v-deep .el-tabs__item.is-active {
    background: linear-gradient(135deg, #6e4ecd 0%, #6d4fdc 100%);
    color: #fff !important;
}

@media (max-width: 991.98px) {
    .leader-board-filter {
        grid-template-columns: 1fr;
    }

    .point-gim {
        width: 124px;
        height: 124px;
    }
}

@media (max-width: 767.98px) {
    .leader-board-wrapper {
        padding: 16px;
        border-radius: 22px;
    }

    .leader-board-toolbar {
        flex-direction: column;
        align-items: stretch;
    }

    .leader-board-month-nav {
        justify-content: space-between;
    }

    .leader-board-month-chip {
        min-width: 0;
        flex: 1;
        text-align: center;
    }

    .leader-board-export {
        width: 100%;
    }

    .leader-board-title {
        font-size: 18px;
    }

    .leader-podium {
        gap: 10px;
    }

    .leader-podium-item {
        max-width: none;
    }

    .point-gim {
        width: 108px;
        height: 108px;
        top: 48%;
    }

    .leader-board-list-wrapper {
        padding: 14px;
        border-radius: 20px;
    }

    .leaderboard-other {
        max-height: 320px;
    }
}

@media (max-width: 575.98px) {
    .leader-podium {
        align-items: stretch;
    }

    .leader-podium-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .leader-podium-name {
        font-size: 13px;
        min-height: 34px;
    }

    .leader-podium-score {
        font-size: 13px;
    }

    .point-gim {
        width: 88px;
        height: 88px;
        border-width: 8px;
        top: 46%;
    }

    .leaderboard-row {
        padding: 12px;
    }

    .leaderboard-row__rank {
        width: 30px;
        height: 30px;
    }
}
</style>
